import React from 'react';
import { IComponentHot, IComponentHotOne } from '../../component';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { style } from '../../utils/image';
import SimpleBigPic from '../BigPic/SimpleBigPic';
import './AllForHot.scss';
import '../common.scss';
import useHot from './useHot';
import { getScrollCls } from '../../utils/util';
import PCScroller from './PCScroller';

// 解析查看更多的跳转链接，返回完整 href
function getShowMoreLink(props: IComponentHot): string | null {
  const { showMore, showMoreType, showMoreUrl, showMorePage } = props;
  if (!showMore) return null;
  if (showMoreType === 'none') return null;
  if (showMoreType === 'url' && showMoreUrl) return showMoreUrl;
  // page 模式：showMorePage 是 link_id，需要拼接 /g/ 前缀
  if (showMoreType === 'page' && showMorePage) return '/g/' + showMorePage;
  return null;
}

export default function AllForHot(props: IComponentHot) {
  const { template, title, hot_list, showMore } = props;
  const { setBigIndex, borderColor, h1Color, bigIndex, bigList, displayList } = useHot(
    props
  );

  const showMoreLink = getShowMoreLink(props);

  const renderVerticalImage = function(img: string, index: number) {
    return (
      <div className="list-one" onClick={() => setBigIndex(index)} key={index}>
        <img src={style(img, 'wx_250_350')} className={'one-photo vertical'} />
      </div>
    );
  };

  const renderHorizontalImage = function(img: string, index: number) {
    return (
      <div className="list-one" onClick={() => setBigIndex(index)} key={index}>
        <img
          src={style(img, 'wx_555_350')}
          className={'one-photo horizontal'}
        />
      </div>
    );
  };

  // list的模式下，没法显示desc
  const renderTemplate1 = function(list: IComponentHotOne[]) {
    if (!list || !list.length) {
      return;
    }
    // 一张
    const len = list.length;
    const imgList: any[] = [];
    const firstImg = list[0].image;
    const lastImg = list[len - 1].image;
    if (len === 1) {
      imgList.push(renderVerticalImage(firstImg, 0));
    } else if (len === 2) {
      list.forEach((one, index) => {
        imgList.push(renderVerticalImage(one.image, index));
      });
    } else {
      // >=3
      imgList.push(renderVerticalImage(firstImg, 0));
      const centerList = list.slice(1, -1);
      centerList.forEach((one, index) => {
        imgList.push(renderHorizontalImage(one.image, index + 1));
      });
      // 最后一个
      imgList.push(renderVerticalImage(lastImg, len - 1));
    }
    // 图片张数>=4时平均分2行显示
    if (len >= 4) {
      const half = Math.ceil(len / 2); //取天花板，第一行可以比第二行多1个
      return (
        <div className={classNames('hot-list template1', getScrollCls())}>
          <div className="row row1">{imgList.slice(0, half)}</div>
          <div className="row row2">{imgList.slice(half)}</div>
        </div>
      );
    }
    return (
      <div
        className={classNames('hot-list template1', getScrollCls())}
        style={{ display: 'flex' }}
      >
        {imgList}
      </div>
    );
  };  

  // 右箭头 SVG（与后台 Icon type="right" 对齐）
  const ArrowRight = () => (
    <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor" style={{ marginLeft: 2, verticalAlign: 'middle' }}>
      <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" />
    </svg>
  );

  // 渲染查看更多链接
  const renderShowMore = () => {
    if (!showMore) return null;

    if (showMoreLink && showMoreLink.startsWith('http')) {
      return (
        <a href={showMoreLink} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: '#24d9cd', whiteSpace: 'nowrap' }}>
          <span>查看更多</span>
          <ArrowRight />
        </a>
      );
    }

    if (showMoreLink) {
      // 内部页面跳转：使用 window.location.href 确保 SPA 整页刷新到目标路由
      return (
        <span
          style={{ fontSize: 12, color: '#24d9cd', whiteSpace: 'nowrap', cursor: 'pointer' }}
          onClick={() => { window.location.href = showMoreLink; }}
        >
          <span>查看更多</span>
          <ArrowRight />
        </span>
      );
    }

    return (
      <span style={{ fontSize: 12, color: '#24d9cd', whiteSpace: 'nowrap' }}>
        查看更多
        <ArrowRight />
      </span>
    );
  };

  // 使用 displayList（支持手动和相册两种来源）
  const renderList = displayList || hot_list || [];

  return (
    <div className={'all-for-hot hot-pic-component decoratev2-comp-com'}>
      <div className="row-wrapper" style={{ color: h1Color }}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          {title && (
          <p className="title" style={{ color: h1Color, width: 'auto', margin: 0 }}>
            {title}
          </p>
        )}
        {renderShowMore()}
        </div>
        <PCScroller>
          {template === 'template1' ? (
            renderTemplate1(renderList)
          ) : (
            <div className={classNames('hot-list', getScrollCls(), template)}>
              {renderList.map((one, index) => (
                <div
                  className={'list-one'}
                  key={index}
                  onClick={() => {
                    setBigIndex(index);
                  }}
                >
                  <img
                    src={style(one.image, 'wx_375_375_square')}
                    className={'one-photo'}
                    style={{ border: `1px solid ${borderColor}` }}
                  />
                  <div className={'one-name'}>{one.desc}</div>
                </div>
              ))}
            </div>
          )}
        </PCScroller>
      </div>
      <SimpleBigPic
        pageType="HotList"
        index={bigIndex}
        list={bigList}
        setIndex={setBigIndex}
        showDetail={true}
      />
    </div>
  );
}
